import {pathOr} from 'ramda';

import {getAllCourseDuration} from '@/src/app/store/courseDetails/useCourseDetailsActions';
import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
const getTransformedPosts = (responseData) => {
  return responseData.map((post) => {
    const image = pathOr(null, ['videos', 0, 'video_preview_image'], post);
    const firstName = pathOr(null, ['creator', 'user', 'first_name'], post);
    const lastName = pathOr(null, ['creator', 'user', 'last_name'], post);

    return {
      previewImage: image ? `${getRootServerUrl()}${image}` : undefined,
      title: post.title,
      author: `${firstName} ${lastName}`,
      id: post.id,
      slug: post.slug,
      duration: image ? getAllCourseDuration([post]) : '',
      isPublic: post?.is_public,
    };
  });
};

export default getTransformedPosts;
